import React, { useEffect, useState } from 'react'
import Header from '../Header'
import Menus from '../MySpace/Menus'
import Profile from '../MySpace/Profile'
import { useNavigate } from "react-router-dom";
import '../MySpace/myspace.css';
import { Col, Container, Image, Row } from 'react-bootstrap';
import Modal from '../Modal';
import { logGuestVisit } from '../../utils/guestVisitLog';
const isMainDomain = () => {
  const hostname = window.location.hostname;
  const mainDomain = process.env.REACT_APP_MAIN_DOMAIN || 'preprod.dastaan.info';
  return hostname === mainDomain || process.env.REACT_APP_DOMAIN === 'main';
};

function Login() {
  const navigate = useNavigate();
  const user_id = localStorage.getItem('dastaan__user_id') !== undefined ? localStorage.getItem('dastaan__user_id') : 0;
  const [showModal, setShowModal] = useState(user_id <= 0);
  const [dw, setWidth] = useState(0);

  // Read URL params for cross-domain redirect (tagged + not subscribed from dastaan.info)
  const queryParams = new URLSearchParams(window.location.search);
  const initialPhone = queryParams.get('phone') || '';
  const initialStep = queryParams.get('step') || 'phone';

  useEffect(() => {
    const w = window.innerWidth;
    setWidth(w);
    logGuestVisit('login-page');
  }, []);

  if (user_id > 0) {
    navigate("/");
  }

  return (
    <>
      <div style={{
        minHeight: '100vh',
        width: '100%',
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/${isMainDomain() ? 'modal-bg.jpg' : 'modal-bg-login.jpg'})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'absolute'
      }}>
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.3)",
          animation: "fadeOverlay 3s infinite alternate",
          zIndex: 1
        }}></div>
        {dw <= 768 ? <Header /> : ''}

        {user_id > 0 ? (
          <>
            <Profile width={dw} />
            <Menus width={dw} />
          </>
        ) : (
          <Modal
            show={showModal}
            onClose={() => setShowModal(false)}
            hideCloseButton={true}
            initialPhone={initialPhone}
            initialStep={initialStep}
          />
        )}
      </div>
    </>
  );
}

export default Login
